import { ParkingBillingSettingForm } from '../../pages/BillingSettingsPage.tsx';

export type BillingType = 'STANDARD_PARKING_BILLING';
export type ScheduleType = 'CRONTAB';
export type OffsetUnit = 'month' | 'week';

export const WeekReportPeriod: ReportPeriodRequest = {
  start: {
    offset_unit: 'week',
    offset: '-1',
    day: '1',
    time: '00:00:00',
  },
  end: {
    offset_unit: 'week',
    offset: '0',
    day: '0',
    time: '23:59:59',
  },
};

export const MonthReportPeriod: ReportPeriodRequest = {
  start: {
    offset_unit: 'month',
    offset: '-1',
    day: '1',
    time: '00:00:00',
  },
  end: {
    offset_unit: 'month',
    offset: '-1',
    day: '31',
    time: '23:59:59',
  },
};

export const FirstHalfOfMonthReportPeriod: ReportPeriodRequest = {
  start: {
    offset_unit: 'month',
    offset: '0',
    day: '1',
    time: '00:00:00',
  },
  end: {
    offset_unit: 'month',
    offset: '0',
    day: '15',
    time: '23:59:59',
  },
};

export const SecondHalfOfMonthReportPeriod: ReportPeriodRequest = {
  start: {
    offset_unit: 'month',
    offset: '-1',
    day: '16',
    time: '00:00:00',
  },
  end: {
    offset_unit: 'month',
    offset: '-1',
    day: '31',
    time: '23:59:59',
  },
};

export interface ReportPeriodRequest {
  start: ReportPeriodOffsetRequest;
  end: ReportPeriodOffsetRequest;
}

// Report 時間 offset 結構
export interface ReportPeriodOffsetRequest {
  offset_unit: OffsetUnit;
  offset: string;
  day: string;
  time: string;
}

// Crontab 設定結構
export interface CrontabSettingsRequest {
  minute: string;
  hour: string;
  monthday: string;
  month: string;
  weekday: string;
}

export interface CrontabRuleRequest {
  type: ScheduleType;
  settings: CrontabSettingsRequest;
}

// Args 結構
export interface BillingArgsRequest {
  storeIds: string[];
  accountantIds: string[];
  billingTags: string[];
  reportPeriod: ReportPeriodRequest;
}

// 主 request 結構
export interface ParkingBillingSettingRequest {
  siteProviderId: string;
  type: BillingType;
  name: string;
  scheduledTaskTriggerRule: CrontabRuleRequest;
  args: BillingArgsRequest;
}

export function createParkingBillingSettingRequest({
  name,
  siteProvider,
  executionType,
  reportPeriodType,
  triggerDay,
  triggerTime,
  storeIds,
  accountantIds,
  tags,
}: ParkingBillingSettingForm): ParkingBillingSettingRequest {
  let reportPeriod = null;
  switch (reportPeriodType) {
    case 'week':
      reportPeriod = WeekReportPeriod;
      break;
    case 'month':
      reportPeriod = MonthReportPeriod;
      break;
    case 'firstHalfOfMonth':
      reportPeriod = FirstHalfOfMonthReportPeriod;
      break;
    case 'secondHalfOfMonth':
      reportPeriod = SecondHalfOfMonthReportPeriod;
      break;
    default:
      throw new Error('Invalid report period type');
  }

  return {
    siteProviderId: siteProvider.id,
    type: 'STANDARD_PARKING_BILLING',
    name,
    scheduledTaskTriggerRule: {
      type: 'CRONTAB',
      settings: {
        minute: '*',
        hour: triggerTime,
        monthday: executionType === 'week' ? '*' : triggerDay,
        month: '*',
        weekday: executionType === 'week' ? triggerDay : '*',
      },
    },
    args: {
      storeIds,
      accountantIds,
      billingTags: tags.map((tag) => tag),
      reportPeriod: reportPeriod,
    },
  };
}
